module.exports = __webpack_public_path__ + "static/media/contact-page-cover.e1e7554a.png";